export default __webpack_public_path__ + "static/media/netflix.5a78c4b9.png";